import { SPage } from "servisofts-component";

import root from "./test";
export default SPage.combinePages("qr",
    {
        "": root,
    }
)